import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import BlankTemplate from 'components/Templates/BlankTemplate';
import ProfileVisaDetails from 'components/Organisms/Profile/VisaDetails';
import { useThunk } from 'hooks/useThunk';
import { fetchVisaDetails } from 'store';
import { useNavigate } from 'react-router-dom';
import useToast from 'components/Provider/useToast';
import downloadFile from 'utils/downloadFile';
import { Box, Skeleton, Typography } from '@mui/material';

const ProfileVisaDetailsPage = () => {
  const navigate = useNavigate();
  const addToast = useToast();

  const [getVisaDetails, isLoadingVisaDetails, loadingVisaDetailsError] = useThunk(fetchVisaDetails);

  useEffect(() => {
    const query = new URLSearchParams({});
    getVisaDetails(query);
  }, [getVisaDetails]);

  const { visaDetails } = useSelector((state) => {
    return state.profile;
  });

  const handleEdit = () => {
    navigate(`/profile/visa-details/edit`);
  };

  const handleAttachment = async (docid, filename) => {
    try {
      await downloadFile({ docid }, filename, 'restPayIndex/downloadAttachment');
    } catch (err) {
      addToast({
        type: 'error',
        title: 'ERROR',
        message: err.message || `Failed to download attachment`,
      });
    }
  };

  if (loadingVisaDetailsError !== null) {
    return <Typography>{loadingVisaDetailsError?.message || 'Error while loading visa details.'}</Typography>;
  }

  return isLoadingVisaDetails ? (
    <Box sx={{ p: 4 }}>
      <Skeleton height={70} />
      <Skeleton />
      <Skeleton />
    </Box>
  ) : (
    <BlankTemplate pageHeading="Visa Details" isBreadcrumb={false} padding="2rem 3rem">
      <ProfileVisaDetails visaDetails={visaDetails} handleEdit={handleEdit} handleAttachment={handleAttachment} />
    </BlankTemplate>
  );
};

export default ProfileVisaDetailsPage;
